import css from './sass/style.scss';

require('./js/anims.js');
require('./js/accordion.js');
require('./js/cards.js')
require('./js/polyfills.js');
require('./js/carousels.js');
require('./js/cookies.js');
require('./js/countdown.js');
require('./js/helpers.js');
require('./js/init.js');
require('./js/inview.js');
require('./js/ismobile.js');
require('./js/lazy.js');
require('./js/popup.js');
require('./js/scrollpos.js');
require('./js/smoothscroll.js');
require('./js/sticky.js');
require('./js/waypoints.js');
